import React from 'react'
import RightBarDataForOtherPages from '../Components/RightBarDataForOtherPages';
import { Grid } from "@material-ui/core";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link, useNavigate } from 'react-router-dom';
import Typography from "@mui/material/Typography";
import useStyle from '../Css/MainCss';
import { ArrowBack} from '@mui/icons-material';
import RiskRegisterComponent from '../Components/RiskRegisterComponent';




function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}





const CreateEditRiskRegister = ({fromMultiTaskin}) => {
  const classes = useStyle();
  const [PageName, setPageName] = React.useState('Risk Register');
  const navigate = useNavigate();
  

  return (
    <>
    {
      fromMultiTaskin ? '':
      <RightBarDataForOtherPages PageName={PageName} />
    }
     
     <div className={fromMultiTaskin ? classes.evapageleft : classes.pageTop} >
        <Grid container spacing={2}>
          <Grid container spacing={2} className={classes.pageBodyStyleRiskReg}>
            {fromMultiTaskin ? '' :
            <>
              <Grid item xs={12}>
              <div role="presentation" onClick={handleClick}>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link underline="hover" color="inherit" to="/login">
                    Home
                  </Link>
                  <Typography color="text.primary">Main menu - {PageName}</Typography>
                </Breadcrumbs>
              </div>
            </Grid>
            <Grid item xs={12}>
              <a style={{ float: 'right', marginTop: '-36px', color: '#0056b3', cursor: 'pointer' }} onClick={() => navigate(-1)}><ArrowBack /> Go Back</a>
            </Grid>
            </>
            }


            <Grid item xs={12}>
              <RiskRegisterComponent/>
            </Grid>
          </Grid>
        </Grid>
      </div>


    </>
  )
}

export default CreateEditRiskRegister